<template>
  <div class="market">
    <div class="market__scroll">
      <CardFace
        v-for="id in ordered"
        :key="id"
        :card-id="id"
        :lowest="buying && id === lowestHouseId && market.length > 1"
      />
    </div>
  </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex';
import CardFace from '@/components/game/CardFace.vue';
import { cardById } from '@/engine/deck';

// The face-up cards in the middle of the table - houses during the buying
// phase, cheques during the selling phase.
//
// Houses are shown cheapest-first so the pass target sits at the left, where
// the eye starts; cheques are shown biggest-first because the ranks people
// are fighting for read top-down. The physical game just scatters them; a
// screen may as well sort.
export default {
  name: 'MarketRow',
  components: { CardFace },
  computed: {
    ...mapState(['game']),
    ...mapGetters(['isBuying', 'lowestHouseId']),
    buying() { return this.isBuying; },
    market() { return this.game?.market || []; },
    ordered() {
      const byValue = (a, b) => cardById(a).value - cardById(b).value;
      return this.buying
        ? [...this.market].sort(byValue)
        : [...this.market].sort((a, b) => byValue(b, a));
    },
  },
};
</script>
